import { FC } from 'react';
import { BaseSection } from 'components/layout/Section/BaseSection';
import { InputFactory } from 'factories/InputFactory';
import { NsKey } from 'enums/NsKey';
import { useDynamicTranslation } from 'hooks/useDynamicTranslation';
import { InputsConfig } from 'types/form/inputsConfig';
import { GerantFieldNames } from './gerantFields';

/**
 * Section « Gérant du cabinet » d'un formulaire de création de personne morale : civilité et
 * mobile du fondateur. `config` est la configuration d'inputs du formulaire hôte, qui doit
 * inclure `gerantInputsConfig`.
 */
export const GerantSection: FC<{ config: InputsConfig<string> }> = ({ config }) => {
  const { t } = useDynamicTranslation([NsKey.ActorForm]);
  return (
    <BaseSection title={t('ACTOR_FORM.GERANT.SECTION')}>
      <p className="mb-3 text-xs text-gray-500">{t('ACTOR_FORM.GERANT.HINT')}</p>
      <div className="grid grid-cols-2 gap-4">
        <div className="col-span-1">
          <InputFactory config={config} fieldName={GerantFieldNames.Civility} />
        </div>
        <div className="col-span-1">
          <InputFactory config={config} fieldName={GerantFieldNames.Phone} />
        </div>
      </div>
    </BaseSection>
  );
};
